<template>
  <div class="guide">
    <p style="color: #000;font-size:14px;">
      使用路径如下：东东企业家 -> 企业应用 -> 企业融资 -> 尽调助手
    </p>
    <p>App下载路径：</p>
    <p>IOS：苹果应用商店</p>
    <p>安卓：请扫描下方二维码下载或到应用商店下载</p>
    <div class="qrcode">
      <vue-qr :text="downloadUrl" :margin="0" colorDark="#333333" colorLight="#fff" :size="200"></vue-qr>
      <p>可扫描上方二维码下载</p>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import vueQr from 'vue-qr'

export default {
  data () {
    return {
      downloadUrl: ''
    }
  },
  methods: {
    getAllVersion () {
      let that = this
      $.ajax({
        url: window.serverconfig.VUE_APP_HOST + '/f/app/getAllVersion',
        type: 'get',
        contentType: 'application/json',
        success: function (res) {
          if (res && res.success) {
            that.downloadUrl = res.data.androidDownloadUrl
            // if (that.$terminal === 'IOS') {
            //   that.downloadUrl = res.data.iosDownloadUrl
            // } else {
            //   that.downloadUrl = res.data.androidDownloadUrl
            // }
          } else {
            alert(res.resMsg)
          }
        }
      })
    }
  },
  created () {
    this.getAllVersion()
    this.$dialog.alert({
      message: '鲸晓APP已经下架，请下载东东企业家APP！',
      theme: 'round-button'
    }).then(() => {
      // on close
    })
  },
  components: {
    vueQr
  }
}
</script>

<style lang="less" scoped>
.guide{
  padding: 20px 15px;
  >p{
    line-height: 24px;
  }
  .qrcode{
    text-align: center;
    img {
      margin-top:20px;
      width: 182px;
      height: 182px;
      background-color: #fff; //设置白色背景色
      padding: 6px; // 利用padding的特性，挤出白边
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/guide.vue